export const CREATE_PRODUCTION67969 = "CREATE_PRODUCTION67969";
export const UPDATE_PRODUCTION67969 = "UPDATE_PRODUCTION67969";
export const DELETE_PRODUCTION67969 = "DELETE_PRODUCTION67969";
export const FETCH_PRODUCTION67969 = "FETCH_PRODUCTION67969";
export const LISTEN_TO_SELECTED_PRODUCTION67969 =
  "LISTEN_TO_SELECTED_PRODUCTION67969";
export const FILTER_PRODUCTION67969 = "FILTER_PRODUCTION67969";
